// extracted by mini-css-extract-plugin
export default {"loading-icon":"_2pHgQ","loadingIcon":"_2pHgQ","loading-opacity":"_2VYNE","loadingOpacity":"_2VYNE"};